import { Component, OnInit } from '@angular/core';

export class AppComponent {

}

@Component({
  selector: 'app-eins-durch-eins',
  templateUrl: './eins-durch-eins.component.html',
  styleUrls: ['./eins-durch-eins.component.css']
})
export class EinsDurchEinsComponent implements OnInit {

  usr_erg: number;
  falsch = 0;
  richtig = 0;
  folge = 0;
  prozent = 0;
  gesamt = 0;

  r_back = 0;
  f_back = 0;

  korrekt: any = {};

  aufgabe: string[] = [];
  ergebnis: number[] = [];

  rand_int: number[] = [];
  rand_return: number;

  bild: any = {};
  bilder: string[] = [];

  t_str: any = {};

  auswahl: boolean[] = [];

  erfolg: boolean;
  programm: boolean;

  i = 0;
  j = 0;
  add_i = 0;

  e: boolean;

  rechnen: boolean;

  alle: boolean;
  gestartet: boolean;
  neuauswahl: boolean;
  neustart: boolean;

  reihen = [
    { name: 'zwei', bez: '2er', number: 2 },
    { name: 'drei', bez: '3er', number: 3 },
    { name: 'vier', bez: '4er', number: 4 },
    { name: 'fuenf', bez: '5er', number: 5 },
    { name: 'sechs', bez: '6er', number: 6 },
    { name: 'sieben', bez: '7er', number: 7 },
    { name: 'acht', bez: '8er', number: 8 },
    { name: 'neun', bez: '9er', number: 9 }
  ];

  neueAufgabe() {
    this.i = 0;
    this.j = 0;
    if(this.alle)
    {
      this.rand_return = Math.floor((Math.random() * 71));
    }
    else
    {
      for (this.j = 2; this.j <= 10; this.j++)
      {
        if (this.auswahl[this.j])
        {
          this.add_i = (this.j - 2) * 8;
          this.rand_int[this.i] = Math.floor((Math.random() * 8 + this.add_i));
          this.i++;
        }
      }
      this.rand_return = this.rand_int[Math.floor((Math.random() * this.i))];
    }
  }

  starten()
  {
    if (!this.auswahl[2] && !this.auswahl[3] && !this.auswahl[4] && !this.auswahl[5] && !this.auswahl[6] && !this.auswahl[7] && !this.auswahl[8] && !this.auswahl[9] && !this.alle)
    {
      alert ('Es muss mindestens eine Reihe ausgewählt werden.');
    }
    else
    {
      this.rechnen = false;
      this.neueAufgabe();
      this.gestartet = true;
      this.neuauswahl = false;
      this.neustart = false;
    }
  }

  neubeginn()
  {
    this.rechnen = true;
    this.gestartet = false;
    this.neuauswahl = true;
    this.neustart = true;
    this.korrekt = '';
  }

  neustarten()
  {
    this.korrekt = '';
    this.falsch = 0;
    this.richtig = 0;
    this.prozent = 0;
    this.rechnen = true;
    this.gestartet = false;
    this.neuauswahl = true;
    this.neustart = true;
    this.folge = 0;
  }

  setEinzeln(e)
  {
    this.rechnen = true;
    if (e)
    {
      this.rechnen = false;
      this.neueAufgabe();
    }
    if (!this.auswahl[2] && !this.auswahl[3] && !this.auswahl[4] && !this.auswahl[5] && !this.auswahl[6] && !this.auswahl[7] && !this.auswahl[8] && !this.auswahl[9])
    {
      this.rechnen = true;
    }
  }

  setAlle()
  {
    if (this.alle)
    {
      for (this.j = 2; this.j <= 10; this.j++)
      {
        this.auswahl[this.j] = true;
      }
      this.neueAufgabe();
    }
    else
    {
      for (this.j = 2; this.j <= 10; this.j++)
      {
        this.auswahl[this.j] = false;
      }
    }
  }

  pruefeErgebnis() {
    this.gesamt++;

    if(this.ergebnis[this.rand_return] === (this.usr_erg))
    {
      this.richtig++;
      this.folge++;
      this.korrekt = '';
      this.prozent = Math.floor(this.falsch * 100 / this.gesamt);
      this.r_back = 1;
      this.f_back = 0;
      setTimeout(() => {
        this.r_back = 0;
      }, 200);
      if (this.folge % 5 == 0)
      {
        this.erfolg = false;
        this.programm = true;
        this.bild = this.bilder[Math.floor((Math.random() * 77))];
      }
      else
      {
        this.erfolg = true;
      }
    }
    else
    {
      this.falsch++;
      this.folge = 0;
      this.korrekt = "richtig wäre: " + this.aufgabe[this.rand_return] + " = " + this.ergebnis[this.rand_return];
      this.prozent = Math.floor(this.falsch * 100 / this.gesamt);
      this.r_back = 0;
      this.f_back = 1;
      setTimeout(() => {
        this.f_back = 0;
      }, 200);
    }
    this.neueAufgabe();
    this.usr_erg = null;
  }

  weiter()
  {
    this.erfolg = true;
    this.programm = false;
  }

  constructor() {
    const BILD_I = 77;
    const DIVISOR_MAX = 9;
    var DIVIDENT_MAX;

    for(let b = 2; b <= DIVISOR_MAX; b++)
    {
      DIVIDENT_MAX = b * 9;
      for(let a = b + 1; a <= DIVIDENT_MAX; a++)
      {
        if(a % b === 0) {
          this.aufgabe.push(`${a}:${b}`);
          this.ergebnis.push(a / b);
        }
      }
    }

    for(let b = 0; b <= BILD_I; b++)
    {
      this.t_str = 'images\\' + b + '.jpg';
      this.bilder.push(this.t_str);
    }
  }

  ngOnInit() {
    this.korrekt = '';
    this.rechnen = true;
    this.programm = false;
    this.erfolg = true;

    for (this.j = 2; this.j <= 10; this.j++)
    {
      this.auswahl[this.j] = false;
    }
    this.gestartet = false;
    this.neuauswahl = true;
    this.neustart = true;
    this.erfolg = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/eins-durch-eins/eins-durch-eins.component.ts